export default __webpack_public_path__ + "static/media/light02.5ab68f47.png";